import Icon from '../components/Icon.vue'

Icon.register({
  passport: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M129.6 176H168.7C170.2 149 175.3 124.6 182.9 105.6 155.2 118.8 134.9 144.8 129.6 176zM129.6 208C134.9 239.2 155.2 265.2 182.9 278.4 175.2 259.4 170.2 235 168.7 208H129.6zM224 286.7C231.7 279.2 244.8 252.3 247.4 208H200.6C203.2 252.3 216.3 279.2 224 286.7zM200.6 176H247.4C244.8 131.7 231.7 104.8 224 97.3 216.3 104.8 203.2 131.7 200.6 176zM265.1 278.4C292.8 265.2 313.1 239.2 318.4 208H279.3C277.8 235 272.8 259.4 265.1 278.4zM416 0H64C28.6 0 0 28.6 0 64V448C0 483.4 28.6 512 64 512H416C433.7 512 448 497.7 448 480V32C448 14.3 433.7 0 416 0zM336 416H112C103.2 416 96 408.8 96 400S103.2 384 112 384H336C344.8 384 352 391.2 352 400S344.8 416 336 416zM224 320C153.3 320 96 262.7 96 192S153.3 64 224 64 352 121.3 352 192 294.7 320 224 320zM265.1 105.6C272.8 124.6 277.8 149 279.3 176H318.4C313.1 144.8 292.8 118.8 265.1 105.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/passport.js
// module id = ePa9
// module chunks = 144